import { useContext } from 'preact/hooks';
import { StoreContext } from './store-provider';
import RootStore from '../stores/root-store';

export const useStore = (): RootStore => {
	return useContext(StoreContext);
};
